// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (min-width: 500px) {
  .menu_mobile {
    display: none;
  }
  .nav_mobile {
    display: none;
  }
  .latest h1 {
    font-size: 1.2rem;
  }
}
@media screen and (max-width: 499px) {
  .latest h1 {
    font-size: 1.5rem;
  }
  .nav {
    display: none;
  }
  .nav_mobile {
    z-index: 10;
    background-color: #042c54;
    width: 100%;
    position: absolute;
    -webkit-transform: translate(-100%, 0);
    transform: translate(-100%, 0);
    transition: transform 0.3s ease;
  }
  .open {
    -webkit-transform: translate(0, 0);
    transform: translate(0, 0);
  }
  .nav_items_mobile {
    display: list-item;
    color: black !important;
    width: 100%;
    text-align: left;
  }
}
@media screen and (min-width: 650px) {
  .list_item_content {
    padding: 16px 32px 32px 32px;
  }
  .list_item_title {
    font-size: 18px;
  }
  .list_item_desc {
    font-size: 14px;
  }
}
@media screen and (min-width: 700px) {
  .latest h1 {
    font-size: 1.7rem;
  }
  .list {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 10px;
    grid-row-gap: 16px;
  }
}
@media screen and (min-width: 900px) {
  .latest h1 {
    font-size: 2rem;
  }
  .list {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
  }
}
@media screen and (min-width: 1200px) {
  main {
    max-width: 1200px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/responsive.css"],"names":[],"mappings":"AAAA;EACE;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;IACX,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,sCAAsC;IACtC,8BAA8B;IAC9B,+BAA+B;EACjC;EACA;IACE,kCAAkC;IAClC,0BAA0B;EAC5B;EACA;IACE,kBAAkB;IAClB,uBAAuB;IACvB,WAAW;IACX,gBAAgB;EAClB;AACF;AACA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;IACrB,kBAAkB;EACpB;AACF;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,aAAa;IACb,kCAAkC;EACpC;AACF;AACA;EACE;IACE,iBAAiB;EACnB;AACF","sourcesContent":["@media screen and (min-width: 500px) {\n  .menu_mobile {\n    display: none;\n  }\n  .nav_mobile {\n    display: none;\n  }\n  .latest h1 {\n    font-size: 1.2rem;\n  }\n}\n@media screen and (max-width: 499px) {\n  .latest h1 {\n    font-size: 1.5rem;\n  }\n  .nav {\n    display: none;\n  }\n  .nav_mobile {\n    z-index: 10;\n    background-color: #042c54;\n    width: 100%;\n    position: absolute;\n    -webkit-transform: translate(-100%, 0);\n    transform: translate(-100%, 0);\n    transition: transform 0.3s ease;\n  }\n  .open {\n    -webkit-transform: translate(0, 0);\n    transform: translate(0, 0);\n  }\n  .nav_items_mobile {\n    display: list-item;\n    color: black !important;\n    width: 100%;\n    text-align: left;\n  }\n}\n@media screen and (min-width: 650px) {\n  .list_item_content {\n    padding: 16px 32px 32px 32px;\n  }\n  .list_item_title {\n    font-size: 18px;\n  }\n  .list_item_desc {\n    font-size: 14px;\n  }\n}\n@media screen and (min-width: 700px) {\n  .latest h1 {\n    font-size: 1.7rem;\n  }\n  .list {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    grid-column-gap: 10px;\n    grid-row-gap: 16px;\n  }\n}\n@media screen and (min-width: 900px) {\n  .latest h1 {\n    font-size: 2rem;\n  }\n  .list {\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr;\n  }\n}\n@media screen and (min-width: 1200px) {\n  main {\n    max-width: 1200px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
